import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import "./PortfolioPage.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import {portfolio} from "../../data";
import ProjectCards from "../../Common/Tab";




function App() {
  return (
    <X03PortfolioPageMobile
      ourProjects="Our Projects"
      rectangle76="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-76-7@2x.png"
    text166="The WeBuildd team of highly skilled and dedicated professionals has been delivering successful projects across all asset classes including, industrial, manufacturing, biotech, residential, healthcare, education, mixed-use, and retail for decades."
    text1662= "We believe that quality construction is much more than choosing materials and craftsmanship. We strive to create an experience our clients can enjoy throughout the construction process. And we deliver beyond the expected so that you have the best possible solution."
    text1663= "As evidenced from our projects, we pay strict attention to small details. As a third-generation family-owned construction firm, we have evolved into a highly-regarded, fully integrated construction firm because our commitment to exceptional quality has never wavered. We are proud of our reputation for quality work and on-time delivery of projects."
    text1664= "We are consistently bringing our clients appropriate and more efficient building solutions in Bengaluru and beyond. We are environmentally responsible. And we have also developed strong working relationships with vendors, which helps minimize costs and unnecessary delays."
    text1665= "Look at our featured projects below:"
      frame145Props={x03PortfolioPageMobileData.frame145Props}
      frame1613Props={x03PortfolioPageMobileData.frame1613Props}
      frame1613Props2={x03PortfolioPageMobileData.frame1613Props2}
    />
  );
}

export default App;

function X03PortfolioPageMobile(props) {
  const { ourProjects, rectangle76, text166,text1662,text1663,text1664,text1665, frame145Props, frame1613Props, frame1613Props2 } = props;

  return (
    <div className="ppm-container-center-horizontal">
      <div className="ppm-x03-portfolio-page-mobile ppm-screen">
        <div className="ppm-frame-1656">
          {/* <Frame145 group86Props={frame145Props.group86Props} iconMenuProps={frame145Props.iconMenuProps} /> */}
          <NavBar/>
          <h1 className="ppm-title ppm-valign-text-middle ppm-typographyheadlineh4-extrabold-24">{ourProjects}</h1>
          {/* <img className="ppm-rectangle-76" src={rectangle76} /> */}
          <img className="ppm-rectangle-76" src={portfolio.PortfolioHeader} alt="Webuildd Projects" />
          <div className="ppm-text-12 ppm-typography-body-smalltext-14-regular">
            <p>{text166}</p>
            <p>{text1662}</p>
            <p>{text1663}</p>
            <p>{text1664}</p>
            <p>{text1665}</p>
          </div>
          <ProjectCards />
          {/* <Frame1613 {...frame1613Props} /> */}
          {/* <Group2122
            group862Props={frame1613Props2.group862Props}
            group872Props={frame1613Props2.group872Props}
            group322Props={frame1613Props2.group322Props}
            frame5Props={frame1613Props2.frame5Props}
          /> */}
          <Footer />
        </div>
      </div>
    </div>
  );
}


function Frame145(props) {
  const { group86Props, iconMenuProps } = props;

  return (
    <div className="ppm-frame-145">
      <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
      <IconMenu vector2={iconMenuProps.vector2} vector3={iconMenuProps.vector3} />
    </div>
  );
}


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="ppm-group-86">
      <White src={whiteProps.src} />
      <img className="ppm-group-85" src="https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg" />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="ppm-white">
      <img className="ppm-vector" src={src} />
    </div>
  );
}


function IconMenu(props) {
  const { vector2, vector3 } = props;

  return (
    <div className="ppm-icon-menu">
      <img
        className="ppm-vector-2"
        src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg"
      />
      <img className="ppm-vector-1" src={vector2} />
      <img className="ppm-vector-1" src={vector3} />
    </div>
  );
}


function Frame1613(props) {
  const {
    apartments,
    buildiings,
    group139Props,
    frame138Props,
    projectCard22Props,
    projectCard222Props,
    projectCard223Props,
    projectCard224Props,
    projectCard225Props,
    projectCard226Props,
    projectCard227Props,
    projectCard228Props,
    projectCard229Props,
    button22Props,
  } = props;

  return (
    <div className="ppm-frame-1613">
      <div className="ppm-frame-1612">
        <div className="ppm-flex-row">
          <Group139>{group139Props.children}</Group139>
          <div className="ppm-apartments ppm-typographybodycaption-14-semi-bold">{apartments}</div>
          <div className="ppm-buildiings ppm-typographybodycaption-14-semi-bold">{buildiings}</div>
        </div>
        <Frame138 place={frame138Props.place} living={frame138Props.living} />
      </div>
      <div className="ppm-frame-1611">
        <ProjectCard22
          rectangle62={projectCard22Props.rectangle62}
          text77={projectCard22Props.text77}
          surname={projectCard22Props.surname}
        />
        <ProjectCard22
          rectangle62={projectCard222Props.rectangle62}
          text77={projectCard222Props.text77}
          surname={projectCard222Props.surname}
          className={projectCard222Props.className}
        />
        <ProjectCard22
          rectangle62={projectCard223Props.rectangle62}
          text77={projectCard223Props.text77}
          surname={projectCard223Props.surname}
          className={projectCard223Props.className}
        />
        <ProjectCard22
          rectangle62={projectCard224Props.rectangle62}
          text77={projectCard224Props.text77}
          surname={projectCard224Props.surname}
          className={projectCard224Props.className}
        />
        <ProjectCard22
          rectangle62={projectCard225Props.rectangle62}
          text77={projectCard225Props.text77}
          surname={projectCard225Props.surname}
          className={projectCard225Props.className}
        />
        <ProjectCard22
          rectangle62={projectCard226Props.rectangle62}
          text77={projectCard226Props.text77}
          surname={projectCard226Props.surname}
          className={projectCard226Props.className}
        />
        <ProjectCard22
          rectangle62={projectCard227Props.rectangle62}
          text77={projectCard227Props.text77}
          surname={projectCard227Props.surname}
          className={projectCard227Props.className}
        />
        <ProjectCard22
          rectangle62={projectCard228Props.rectangle62}
          text77={projectCard228Props.text77}
          surname={projectCard228Props.surname}
          className={projectCard228Props.className}
        />
        <ProjectCard22
          rectangle62={projectCard229Props.rectangle62}
          text77={projectCard229Props.text77}
          surname={projectCard229Props.surname}
          className={projectCard229Props.className}
        />
      </div>
      <Button22>{button22Props.children}</Button22>
    </div>
  );
}


function Group139(props) {
  const { children } = props;

  return (
    <div className="ppm-group-139">
      <div className="ppm-overlap-group">
        <div className="ppm-rectangle-46"></div>
        <div className="ppm-price">{children}</div>
      </div>
    </div>
  );
}


function Frame138(props) {
  const { place, living } = props;

  return (
    <div className="ppm-frame-138">
      <div className="ppm-place ppm-typographybodycaption-14-semi-bold">{place}</div>
      <div className="ppm-living ppm-typographybodycaption-14-semi-bold">{living}</div>
    </div>
  );
}


function ProjectCard22(props) {
  const { rectangle62, text77, surname, className } = props;

  return (
    <div className={`ppm-project-card-1 ${className || ""}`}>
      <img className="ppm-rectangle-62" src={rectangle62} />
      <div className="ppm-group-99">
        <div className="ppm-text ppm-valign-text-middle ppm-typographyheadlineh4-extrabold-24">{text77}</div>
        <p className="ppm-surname ppm-typography-body-smalltext-14-regular">{surname}</p>
      </div>
    </div>
  );
}


function Button22(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x27320769TimelineData);
  }, []);

  return (
    <div className="ppm-x27320769 ppm-component ppm-component-wrapper ppm-not-ready">
      <div className="ppm-master-button-A5N4Z6">
        <div className="ppm-button-i2732076951-Zn9NwL ppm-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const x27320769TimelineData = [
  {
    initial_state_name: "Property-1=Tertiary",
    root_element: ".ppm-x27320769",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


// function Group2122(props) {
//   const { group862Props, group872Props, group322Props, frame5Props } = props;

//   return (
//     <div className="ppm-group-212">
//       <div className="ppm-flex-row-1">
//         <Group8622 group85={group862Props.group85} />
//         <Group872
//           overlapGroup={group872Props.overlapGroup}
//           vector2={group872Props.vector2}
//           facebookAppSymbolProps={group872Props.facebookAppSymbolProps}
//           twitterProps={group872Props.twitterProps}
//         />
//       </div>
//       <Group322 {...group322Props} />
//       <Frame5
//         quickLinks={frame5Props.quickLinks}
//         frame140Props={frame5Props.frame140Props}
//         frame1402Props={frame5Props.frame1402Props}
//         frame1403Props={frame5Props.frame1403Props}
//       />
//     </div>
//   );
// }


function Group8622(props) {
  const { group85 } = props;

  return (
    <div className="ppm-group-86-1">
      <div className="ppm-white-1">
        <img
          className="ppm-vector-3"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
        />
      </div>
      <img className="ppm-group-85-1" src={group85} />
    </div>
  );
}


function Group872(props) {
  const { overlapGroup, vector2, facebookAppSymbolProps, twitterProps } = props;

  return (
    <div className="ppm-group-87">
      <FacebookAppSymbol src={facebookAppSymbolProps.src} />
      <div className="ppm-instagram">
        <div className="ppm-overlap-group-1" style={{ backgroundImage: `url(${overlapGroup})` }}>
          <img
            className="ppm-vector-4"
            src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-110@2x.svg"
          />
          <img className="ppm-vector-5" src={vector2} />
        </div>
      </div>
      <Twitter src={twitterProps.src} />
    </div>
  );
}


function FacebookAppSymbol(props) {
  const { src } = props;

  return (
    <div className="ppm-facebook-app-symbol">
      <img className="ppm-f-1" src={src} />
    </div>
  );
}


function Twitter(props) {
  const { src } = props;

  return (
    <div className="ppm-twitter">
      <img className="ppm-vector-6" src={src} />
    </div>
  );
}


function Group322(props) {
  const { place, overlapGroup, phone, overlapGroup1, vector2, text165, text164, contactWebuildCom } = props;

  return (
    <div className="ppm-group-32">
      <div className="ppm-place-1 ppm-valign-text-middle ppm-typographyheadlineh5-extrabold-20">{place}</div>
      <div className="ppm-flex-row-2">
        <div className="ppm-flex-col">
          <div className="ppm-map-pin-1">
            <div className="ppm-overlap-group-2" style={{ backgroundImage: `url(${overlapGroup})` }}>
              <img
                className="ppm-vector-7"
                src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-244@2x.svg"
              />
            </div>
          </div>
          <div className="ppm-phone" style={{ backgroundImage: `url(${phone})` }}></div>
          <div className="ppm-mail">
            <div className="ppm-overlap-group1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
              <img className="ppm-vector-8" src={vector2} />
            </div>
          </div>
        </div>
        <div className="ppm-flex-col-1">
          <p className="ppm-text-11 ppm-typography-body-smalltext-14-regular">{text165}</p>
          <div className="ppm-flex-col-item ppm-valign-text-middle ppm-typography-body-smalltext-14-regular">{text164}</div>
          <div className="ppm-flex-col-item ppm-valign-text-middle ppm-typography-body-smalltext-14-regular">
            {contactWebuildCom}
          </div>
        </div>
      </div>
    </div>
  );
}


function Frame5(props) {
  const { quickLinks, frame140Props, frame1402Props, frame1403Props } = props;

  return (
    <div className="ppm-frame-5">
      <div className="ppm-quick-links ppm-valign-text-middle ppm-typographyheadlineh5-extrabold-20">{quickLinks}</div>
      <div className="ppm-frame-4">
        <Frame140 aboutUs={frame140Props.aboutUs} projects={frame140Props.projects} />
        <Frame140
          aboutUs={frame1402Props.aboutUs}
          projects={frame1402Props.projects}
          className={frame1402Props.className}
        />
        <Frame140
          aboutUs={frame1403Props.aboutUs}
          projects={frame1403Props.projects}
          className={frame1403Props.className}
        />
      </div>
    </div>
  );
}


function Frame140(props) {
  const { aboutUs, projects, className } = props;

  return (
    <div className={`ppm-frame-140 ${className || ""}`}>
      <div className="ppm-about-us ppm-valign-text-middle ppm-typographybody16-regular">{aboutUs}</div>
      <div className="ppm-projects ppm-valign-text-middle ppm-typographybody16-regular">{projects}</div>
    </div>
  );
}

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-3@2x.svg",
    whiteProps: whiteData,
};

const iconMenuData = {
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
};

const frame145Data = {
    group86Props: group86Data,
    iconMenuProps: iconMenuData,
};

const group139Data = {
    children: "ALL",
};

const frame138Data = {
    place: "INTERIOR",
    living: "LIVING",
};

const projectCard22Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-24@2x.png",
    text77: "Project Name",
    surname: "Small description about the project",
};

const projectCard222Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-25@2x.png",
    text77: "Project Name",
    surname: "Small description about the project",
    className: "ppm-project-card",
};

const projectCard223Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-26@2x.png",
    text77: "Project Name",
    surname: "Small description about the project",
    className: "ppm-project-card",
};

const projectCard224Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-27@2x.png",
    text77: "Project Name",
    surname: "Small description about the project",
    className: "ppm-project-card",
};

const projectCard225Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-28@2x.png",
    text77: "Project Name",
    surname: "Small description about the project",
    className: "ppm-project-card",
};

const projectCard226Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-29@2x.png",
    text77: "Project Name",
    surname: "Small description about the project",
    className: "ppm-project-card",
};

const projectCard227Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-30@2x.png",
    text77: "Project Name",
    surname: "Small description about the project",
    className: "ppm-project-card",
};

const projectCard228Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-31@2x.png",
    text77: "Project Name",
    surname: "Small description about the project",
    className: "ppm-project-card",
};

const projectCard229Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-32@2x.png",
    text77: "Project Name",
    surname: "Small description about the project",
    className: "ppm-project-card",
};

const button22Data = {
    children: "VIEW MORE",
};

const frame1613Data = {
    apartments: "APARTMENTS",
    buildiings: "BUILDIINGS",
    group139Props: group139Data,
    frame138Props: frame138Data,
    projectCard22Props: projectCard22Data,
    projectCard222Props: projectCard222Data,
    projectCard223Props: projectCard223Data,
    projectCard224Props: projectCard224Data,
    projectCard225Props: projectCard225Data,
    projectCard226Props: projectCard226Data,
    projectCard227Props: projectCard227Data,
    projectCard228Props: projectCard228Data,
    projectCard229Props: projectCard229Data,
    button22Props: button22Data,
};

const group8622Data = {
    group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-26@2x.svg",
};

const facebookAppSymbolData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-1@2x.svg",
};

const twitterData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-157@2x.svg",
};

const group872Data = {
    overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-154@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-156@2x.svg",
    facebookAppSymbolProps: facebookAppSymbolData,
    twitterProps: twitterData,
};

const group322Data = {
    place: "Contact",
    overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-243@2x.svg",
    phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-245@2x.svg",
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-246@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-153@2x.svg",
    text165: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
    text164: "+91 8976535221, +91 8755645342",
    contactWebuildCom: "contact@webuild.com",
};

const frame140Data = {
    aboutUs: "About Us",
    projects: "Projects",
};

const frame1402Data = {
    aboutUs: "Gallery",
    projects: "Knowledge Transfer",
    className: "ppm-frame-14-1",
};

const frame1403Data = {
    aboutUs: "Blogs",
    projects: "FAQ’s",
    className: "ppm-frame-14",
};

const frame5Data = {
    quickLinks: "Quick Links",
    frame140Props: frame140Data,
    frame1402Props: frame1402Data,
    frame1403Props: frame1403Data,
};

// const group2122Data = {
//     group862Props: group8622Data,
//     group872Props: group872Data,
//     group322Props: group322Data,
//     frame5Props: frame5Data,
// };

const x03PortfolioPageMobileData = {
    frame145Props: frame145Data,
    frame1613Props: frame1613Data,
    //frame1613Props2: group2122Data,
};

